// rrweb records the page as-is, as agreed for Genesis: only password fields are
// masked and one-time-code fields are blocked outright. Loaded on demand so the
// recorder never sits in the first-load bundle.
export async function startReplay(onEvents: (events: unknown[]) => void): Promise<() => void> {
  const { record } = await import("rrweb");
  let buffer: unknown[] = [];
  const stopRecording = record({
    emit(event) { buffer.push(event); },
    maskInputOptions: { password: true },
    blockSelector: 'input[autocomplete="one-time-code"], [data-telemetry-block]',
    recordCanvas: false,
    collectFonts: false,
    sampling: { mousemove: 50, scroll: 150, input: "last" },
  });
  const timer = setInterval(() => {
    if (buffer.length) { onEvents(buffer); buffer = []; }
  }, 5_000);
  return () => {
    clearInterval(timer);
    stopRecording?.();
    if (buffer.length) onEvents(buffer);
  };
}
